import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAccessToken,
  clearAccessToken,
  submitFragebogen,
  getUserAnswers,
} from "../utils/fetchFunctions";

/**
 * @description Loads the user's maturity level progress for the dashboard visualization pages.
 * Redirects to the login page when no valid session exists.
 * @returns {Object} { levelProgress, loading, error }
 */
const useMaturityData = () => {
  const [levelProgress, setLevelProgress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      navigate("/login");
      return;
    }

    const loadData = async () => {
      setLoading(true);
      try {
        const answersData = await getUserAnswers();
        if (answersData && answersData.length > 0) {
          const result = await submitFragebogen();
          setLevelProgress(result.levelProgress);
        }
      } catch (err) {
        if (err.message && err.message.includes("401")) {
          clearAccessToken();
          navigate("/login");
          return;
        }
        setError(err.message || "Error loading data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [navigate]);

  return { levelProgress, loading, error };
};

export default useMaturityData;
